import React from 'react';
import { Eye, Send, FileText } from 'lucide-react';

export function ComposeTab({
  activeSubscribers,
  subject,
  setSubject,
  content,
  setContent,
  sending,
  sendResult,
  onPreview,
  onSend,
}) {
  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-gold-500/20 rounded-lg flex items-center justify-center">
          <FileText className="text-gold-400" size={20} />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-white">Compose Newsletter</h2>
          <p className="text-gray-400 text-sm">Send to {activeSubscribers} active subscribers</p>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-gray-300 text-sm font-medium mb-2">Subject Line</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="e.g., New Music Coming Soon!"
            className="w-full bg-gray-900/50 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500"
            data-testid="newsletter-subject"
          />
        </div>

        <div>
          <label className="block text-gray-300 text-sm font-medium mb-2">Message Content</label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder={"Write your newsletter message here...\n\nYou can include updates about new music, upcoming shows, behind-the-scenes content, and more!"}
            rows={10}
            className="w-full bg-gray-900/50 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500 resize-none"
            data-testid="newsletter-content"
          />
        </div>

        {sendResult && (
          <div className={`p-4 rounded-lg ${sendResult.success ? 'bg-green-500/20 border border-green-500/50' : 'bg-red-500/20 border border-red-500/50'}`}>
            <p className={sendResult.success ? 'text-green-400' : 'text-red-400'}>
              {sendResult.message}
            </p>
            {sendResult.results && (
              <p className="text-gray-400 text-sm mt-1">
                Successful: {sendResult.results.successful} | Failed: {sendResult.results.failed}
              </p>
            )}
          </div>
        )}

        <div className="flex gap-3 pt-2">
          <button
            onClick={onPreview}
            disabled={!subject || !content}
            className="flex items-center gap-2 bg-gray-700 hover:bg-gray-600 px-5 py-3 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="preview-btn"
          >
            <Eye size={18} />
            Preview
          </button>
          <button
            onClick={onSend}
            disabled={sending || !subject || !content}
            className="flex items-center gap-2 bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-400 hover:to-gold-500 text-black font-semibold px-6 py-3 rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="send-newsletter-btn"
          >
            <Send size={18} />
            {sending ? 'Sending...' : 'Send Newsletter'}
          </button>
        </div>
      </div>
    </div>
  );
}
